<form [formGroup]="form" (ngSubmit)="onSubmit()">


  <div class="form-row">

    <div class="form-group col">
      <div style="    display: grid;    grid-template-columns: 200px auto;    gap: 15px;">
        <div style="position: relative;">
          {{ label_nm }}
        </div>
        <div style="position: relative;">
          <input type="password" name="Userkey" id="userkey" class="form-control" placeholder="Enter Key" formControlName="autoUserID" [ngClass]="{ 'is-invalid': submitted && f.autoUserID.errors }" />
          <div *ngIf="submitted && f.autoUserID.errors" class="invalid-feedback">
            <div *ngIf="f.autoUserID.errors.required">Key required</div>
          </div>
          <div style="position: relative;">
            {{ label_nm }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-row">

    <div class="form-group col">
      <button class="btn btn-primary" [disabled]="loading">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        Authenticate
      </button>




    </div>
  </div>
  <!--{{item}}-->
  
</form>
